import { isHotkey } from '../../../../../../utilities/hotkeys/hotkeys.mjs';

const Type = 'hotkey';
const HotkeyPlugin = ({
  hotkeys
}) => ({
  type: Type,
  onKeyDown(event, editor) {
    for (const {
      hotkey,
      handler
    } of hotkeys) {
      if (hotkey && isHotkey(event, hotkey)) {
        event.preventDefault();
        handler(editor, event);
        return;
      }
    }
  }
});

export { HotkeyPlugin, Type };
